import { getResourceBytes, getResourceText } from '../io/api/resource/client'

export { getResourceBytes as fetchResourceBytes }

export const fetchText = async (url: string): Promise<string | undefined> => {
  const response = await fetch(url)
  return response.ok ? response.text() : undefined
}

export const fetchResourceText = async (resourceId: string): Promise<string | undefined> =>
  (await getResourceText(resourceId)) ?? undefined
